module.exports = __webpack_public_path__ + "static/media/aircall-icon-white.89e81a40.svg";